// vg-smart-header: header hides on scroll down, REAPPEARS on scroll up (Marco-style smart reveal)
//
// 2026-09-03 — mega menu fix. This script pins #header-group with position:fixed and hides it with
// transform:translateY(-110%). The mega menu panel is a child of the header, so ANY downward scroll
// while the menu was open yanked the whole panel off screen — which is what "the mega menu bugs,
// you can't drag the mouse into it, one time out of two it retracts" was. Two guards added:
//   1. never hide while a mega menu is open or while the pointer is over the header
//   2. ignore sub-threshold scroll deltas, so trackpad jitter and the layout shift caused by the
//      panel opening no longer count as "scrolling down"
(function () {
  function pick() {
    // Prefer the whole header group wrapper (so announcement/marquee bar stays ON TOP of the header).
    var cands = ['#header-group', '.header-wrapper', '#header-component', 'header.header', '.section-header', 'header'];
    for (var i = 0; i < cands.length; i++) {
      var e = document.querySelector(cands[i]);
      if (e && e.getBoundingClientRect().height > 20) return e;
    }
    return document.querySelector('#header-group') || document.querySelector('#header-component') || document.querySelector('header');
  }

  /** True while a mega menu / submenu is open, or the cursor is inside the header. */
  function headerIsBusy(h) {
    if (!h) return false;
    if (h.matches(':hover')) return true;
    if (h.querySelector('header-menu[aria-expanded="true"]')) return true;
    if (h.querySelector('.menu-list__link[aria-expanded="true"]')) return true;
    if (h.querySelector('.menu-list__submenu[data-active]')) return true;
    // drawer / search / cart overlays own the header too
    if (h.querySelector('dialog[open], details[open]')) return true;
    return false;
  }

  function init() {
    var h = pick();
    if (!h) return;
    // Clear any leftover inline pinning on the inner header component so the group measures/flows correctly.
    var inner = document.querySelector('#header-component');
    if (inner && inner !== h) { inner.style.position = ''; inner.style.top = ''; inner.style.transform = ''; inner.style.transition = ''; }
    // Force the header FIXED (pins to viewport reliably, unlike sticky which depends on containing block),
    // and pad the body so page content isn't hidden under it.
    var hh = Math.round(h.getBoundingClientRect().height) || 90;
    h.style.position = 'fixed';
    h.style.top = '0'; h.style.left = '0'; h.style.right = '0'; h.style.width = '100%';
    h.style.zIndex = '1000';
    h.style.transition = 'transform .35s ease';
    if (!document.body.dataset.vgHeaderPad) { document.body.style.paddingTop = hh + 'px'; document.body.dataset.vgHeaderPad = '1'; }

    var lastY = Math.max(0, window.scrollY || 0);
    var ticking = false;
    var THRESHOLD = 8; // px — below this it's jitter, not a scroll gesture

    function show() { h.style.transform = 'translateY(0)'; }

    function upd() {
      ticking = false;
      var y = Math.max(0, window.scrollY || 0);
      var delta = y - lastY;

      // An open mega menu (or a hovered header) always wins: keep the header put and
      // re-baseline, so the panel can never be dragged off screen mid-interaction.
      if (headerIsBusy(h)) { show(); lastY = y; return; }

      if (Math.abs(delta) < THRESHOLD) return; // ignore jitter, keep lastY as the reference

      if (delta > 0 && y > 150) h.style.transform = 'translateY(-110%)';
      else if (delta < 0) show();

      lastY = y;
    }

    window.addEventListener('scroll', function () { if (!ticking) { window.requestAnimationFrame(upd); ticking = true; } }, { passive: true });

    // Belt and braces: opening a menu or moving the pointer back into the header reveals it at once.
    h.addEventListener('pointerenter', show);
    h.addEventListener('focusin', show);
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init, { once: true }); } else { init(); }
})();
